import { Paper, Skeleton, Stack } from '@mantine/core';

/**
 * Placeholder for the recipe Notes card: on the details page's loading
 * skeleton, and while a list-item summary previews the page (summaries don't
 * carry notes, so whether the recipe has any isn't known yet). Mirrors the
 * card: a "Notes" title over a bordered paper of text lines.
 */
export const NotesSkeleton = () => (
  <Stack gap="md">
    <Skeleton height={22} width={70} />
    <Paper p={{ base: 'lg', sm: 'md' }} radius="lg" withBorder>
      <Stack gap="xs">
        <Skeleton height={14} width="100%" />
        <Skeleton height={14} width="90%" />
        <Skeleton height={14} width="60%" />
      </Stack>
    </Paper>
  </Stack>
);
